import { WorkHistoryFields } from "modules/self-apply/validation/candidate-self-apply";
import { MultiFieldSet } from "../../../../../../components/utils/useFieldSet";
import { PublicJobSectionGraph } from "../../../../../graphql.types";
import { WorkHistoryFragment } from "../../../../components/self-apply-application-form-fragments/work-history";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";

export const SelfApplyWorkHistoryAppSection = (props: {
  fieldSet: MultiFieldSet<WorkHistoryFields>;
  section: PublicJobSectionGraph;
}) => {
  const { section, fieldSet } = props;
  return (
    <SelfApplySectionContainer.Container
      key={section.id}
      description={section.description ?? ""}
      title={section.name ?? ""}
      isRequired={section?.isRequired ?? false}
    >
      <SelfApplySectionContainer.Content>
        <div className="pt-8">
          <WorkHistoryFragment
            {...fieldSet}
            isRequired={section?.isRequired ?? false}
            employerRequired
            startDateRequired
            positionRequired
            endDateRequired
            hasAllValid={fieldSet.hasAllValid && !fieldSet.notEnoughItems}
          />
        </div>
      </SelfApplySectionContainer.Content>
    </SelfApplySectionContainer.Container>
  );
};
